module.exports = __webpack_public_path__ + "static/img/3.6c16f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newSix/3.png
// module id = 7LVY
// module chunks = 0